import { CircularProgress } from '@mui/material';
import './styles.scss';

export const BacktestLoading = () => {
  return (
    <div className="backtest-loading">
      <div className="backtest-loading-content">
        <CircularProgress size={40} />
        <span className="backtest-loading-content-text">Calculating...</span>
      </div>
    </div>
  );
};
